// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// eslint-disable-next-line no-unused-vars
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBYswI7PMj3Q4T6zrAuEK8A4lAwHL7MkH8",
  authDomain: "bottle-depot.firebaseapp.com",
  databaseURL: "https://bottle-depot-default-rtdb.firebaseio.com",
  projectId: "bottle-depot",
  storageBucket: "bottle-depot.firebasestorage.app",
  messagingSenderId: "945784374439",
  appId: "1:945784374439:web:3526f97b7e8b5112438782",
  measurementId: "G-LRGR4RYCEF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app, "website")

export default db